module.exports = "https://99designs-start-assets.imgix.net/js/c77fc61cc35208f67f00113ab3e7343b.png";